import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    this.onWheel = this.onWheel.bind(this)
    this.element.addEventListener("wheel", this.onWheel, { passive: false })
  }

  disconnect () {
    this.element.removeEventListener("wheel", this.onWheel)
  }

  onWheel (event) {
    if (this.element.scrollWidth <= this.element.clientWidth) return
    if (event.deltaY === 0) return

    event.preventDefault()
    this.element.scrollLeft += event.deltaY
  }
}
